import React from 'react';
import PropTypes from 'prop-types';
import { UiFormControlLabel, UiRadio, UiRadioGroup } from 'ui-components';

export function IncludeOrExcludeRadios(props) {
  const {
    onSearchTypeChange,
    selectedValue,
    disabled,
    includeLabel,
    excludeLabel,
  } = props;

  const handleSearchTypeChange = (event) => {
    onSearchTypeChange(event);
  };
  return (
    <UiRadioGroup onChange={handleSearchTypeChange}>
      <UiFormControlLabel
        className='mr-0'
        label={includeLabel}
        control={
          <UiRadio checked={selectedValue === 'include'} value='include' />
        }
        disabled={disabled}
      />
      <UiFormControlLabel
        className='mr-0'
        label={excludeLabel}
        control={
          <UiRadio checked={selectedValue === 'exclude'} value='exclude' />
        }
        disabled={disabled}
      />
    </UiRadioGroup>
  );
}

IncludeOrExcludeRadios.propTypes = {
  onSearchTypeChange: PropTypes.func,
  selectedValue: PropTypes.string,
  disabled: PropTypes.bool,
  includeLabel: PropTypes.string.isRequired,
  excludeLabel: PropTypes.string.isRequired,
};
